import React from 'react';
import './RulesPage.css';

export default function RulesPage() {
  return (
    <div className="rules-page">
      <h1>Competition Rules</h1>
      <p className="rules-subtitle">Standard rules for league competitions</p>

      <section className="rules-section">
        <h2>Match Format</h2>
        <ul>
          <li>Matches are played under <strong>World Blackball Rules</strong>.</li>
          <li>Each match consists of 7 individual frames (best of 7).</li>
          <li>Teams nominate their playing order before the match begins.</li>
          <li>The home team provides the table and breaks first in frame 1. The break alternates each frame.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Scoring</h2>
        <ul>
          <li><strong>3 points</strong> for a match win.</li>
          <li><strong>1 point</strong> for a match draw.</li>
          <li><strong>0 points</strong> for a match loss.</li>
          <li>Standings are ranked by: points, then frame difference, then frames won.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Result Submission</h2>
        <ul>
          <li>Both team captains must submit results within 48 hours of the match.</li>
          <li>If results conflict, the organiser will be notified to resolve the dispute.</li>
          <li>Results are final once both captains have approved.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Postponements</h2>
        <ul>
          <li>Matches may be postponed by mutual agreement of both captains.</li>
          <li>Postponed matches must be replayed within 14 days of the original date.</li>
          <li>Notify the organiser of any postponement.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Player Eligibility</h2>
        <ul>
          <li>Only registered team members may play in league matches.</li>
          <li>A player may only be registered to one team per competition.</li>
          <li>New player registrations close at the halfway point of the season.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Conduct</h2>
        <ul>
          <li>All players are expected to behave in a sporting manner.</li>
          <li>Disputes during a frame should be resolved by agreement or by replaying the shot.</li>
          <li>Persistent unsportsmanlike conduct may result in disciplinary action by the organiser.</li>
        </ul>
      </section>

      <p className="rules-footer">
        These are the default competition rules. Individual competitions may have additional or amended rules set by the organiser.
      </p>
    </div>
  );
}
